module.exports = __webpack_public_path__ + "img/2.ac5dd868.png";